import React from 'react'

const Footer = () => (
  <footer className='site-footer'>
    <div className='container'>
      <div className='footer-content'>
        <div className='footer-column'>
          <h3>Rokyet Ventures Ltd</h3>
          <p>
            Delivering innovative software solutions that drive business growth
            and operational efficiency.
          </p>
          <br />
          <p>Custom Solutions. Made Simple. Made Right</p>
        </div>

        <div className='footer-column'>
          <h3>Quick Links</h3>
          <ul className='footer-links'>
            <li>
              <a href='#home'>Home</a>
            </li>
            <li>
              <a href='#about'>About Us</a>
            </li>
            <li>
              <a href='#services'>Services</a>
            </li>
            <li>
              <a href='#aropmis'>AroPMIS</a>
            </li>
          </ul>
        </div>

        <div className='footer-column'>
          <h3>Contact Info</h3>
          <ul>
            <li>
              <i class='fas fa-map-marker-alt'></i> 3rd Floor, Rm 6D, 64 Arcade,
              Eldoret, Kenya
            </li>
            <li>
              <i class='fas fa-phone'></i> +254 797 922 279 / +254 729 174 776
            </li>
            <li>
              <i class='fas fa-envelope'></i> info@rokyetventures.com
            </li>
          </ul>
        </div>
      </div>

      <div className='footer-bottom'>
        <p>
          &copy; {new Date().getFullYear()} Rokyet Ventures Ltd. All Rights
          Reserved.
        </p>
      </div>
    </div>
  </footer>
)

export default Footer
